<template>

  <div class="containerBox">
      <div class="zxkc_tile">学生作品</div>
      <div class="zxkc_content">
          <div class="zxkc_content_left">
            <div class="zxkc_content_left_item_unactive"
                    :class="type == '主要赛事' ? 'zxkc_content_left_item_active' : ''" @click="changeType('主要赛事')">主要赛事
                </div>
                <div class="zxkc_content_left_item_unactive"
                    :class="type == '学生论文' ? 'zxkc_content_left_item_active' : ''" @click="changeType('学生论文')">学生论文
                </div>
                <div class="zxkc_content_left_item_unactive"
                    :class="type == '学生专利' ? 'zxkc_content_left_item_active' : ''" @click="changeType('学生专利')">学生专利
                </div>
                <div class="zxkc_content_left_item_unactive"
                    :class="type == '学生获奖' ? 'zxkc_content_left_item_active' : ''" @click="changeType('学生获奖')">学生获奖
                </div>

          </div>
          <div class="zxkc_content_center"></div>
          <div class="zxkc_content_right_type2" v-if="type == '主要赛事'">
              <div  class="zxkc_content_right_ppt" v-if="listShow.length > 0"  >
                  <div class="zxkc_content_right_ppt_item" v-for="(item, index) in  listShow">
                      <div class="zxkc_content_right_ppt_item_text">
                        <div style="width: 10%;font-size: 16px;color: #333333;text-align: center; border-right: 1.5px solid #070002; border-color: rgba(0, 0, 0, 0.1);display: -webkit-box;
-webkit-line-clamp: 1;
-webkit-box-orient: vertical;
overflow: hidden;
text-overflow: ellipsis;">{{ item.studentName}}</div>
                          <div class="zxkc_content_right_ppt_item_text_left_unactive" :class="item.active == true ? 'zxkc_content_right_ppt_item_text_left' : ''"  @mouseover="item.active = true"
                          @mouseleave="item.active = false" @click="toDetail(item)">{{ item.title }}</div>
                          <div class="zxkc_content_right_ppt_item_text_right" @click="toDetail(item)" >在线预览>></div>
                      </div>
                      <div class="zxkc_content_right_ppt_item_line">
                      </div>
                  </div>
                  <div class="el_pagination">
                        <el-pagination background layout="prev, pager, next" :page-size="9" :total="total"
                            @current-change="pageChange">
                        </el-pagination>
                    </div>
              </div>
              <div v-else
                    style="height: 100%; width: 100%;  display: flex; justify-content: center; color: #333333;">
                    <img style="height: 50%; width: 40%; object-fit: cover;"  src="../images/bgk.jpg"/>
                     
                </div>
          </div>
          <div class="zxkc_content_right_type2" v-if="type == '学生论文'">
            <div  class="zxkc_content_right_ppt" v-if="listShow.length > 0"  >
                  <div class="zxkc_content_right_ppt_item" v-for="(item, index) in  listShow">
                      <div class="zxkc_content_right_ppt_item_text">
                        <div style="width: 10%;font-size: 16px;color: #333333;text-align: center; border-right: 1.5px solid #070002; border-color: rgba(0, 0, 0, 0.1);display: -webkit-box;
-webkit-line-clamp: 1;
-webkit-box-orient: vertical;
overflow: hidden;
text-overflow: ellipsis;">{{ item.studentName}}</div>
                          <div class="zxkc_content_right_ppt_item_text_left_unactive" :class="item.active == true ? 'zxkc_content_right_ppt_item_text_left' : ''"  @mouseover="item.active = true"
                          @mouseleave="item.active = false" @click="toDetail(item)">{{ item.title }}</div>
                          <div class="zxkc_content_right_ppt_item_text_right" @click="toDetail(item)" >在线预览>></div>
                      </div>
                      <div class="zxkc_content_right_ppt_item_line">
                      </div>
                  </div>
                  <div class="el_pagination">
                        <el-pagination background layout="prev, pager, next" :page-size="9" :total="total"
                            @current-change="pageChange">
                        </el-pagination>
                    </div>
              </div>
              <div v-else
                    style="height: 100%; width: 100%;  display: flex; justify-content: center; color: #333333;">
                    <img style="height: 50%; width: 40%; object-fit: cover;"  src="../images/bgk.jpg"/>
                     
                </div>
          </div>
          <div class="zxkc_content_right_type2" v-if="type == '学生专利'">
            <div  class="zxkc_content_right_ppt" v-if="listShow.length > 0"  >
                  <div class="zxkc_content_right_ppt_item" v-for="(item, index) in  listShow">
                      <div class="zxkc_content_right_ppt_item_text">
                        <div style="width: 10%;font-size: 16px;color: #333333;text-align: center; border-right: 1.5px solid #070002; border-color: rgba(0, 0, 0, 0.1);display: -webkit-box;
-webkit-line-clamp: 1;
-webkit-box-orient: vertical;
overflow: hidden;
text-overflow: ellipsis;">{{ item.studentName}}</div>
                          <div class="zxkc_content_right_ppt_item_text_left_unactive" :class="item.active == true ? 'zxkc_content_right_ppt_item_text_left' : ''"  @mouseover="item.active = true"
                          @mouseleave="item.active = false" @click="toDetail(item)">{{ item.title }}</div>
                          <div class="zxkc_content_right_ppt_item_text_right" @click="toDetail(item)" >在线预览>></div>
                      </div>
                      <div class="zxkc_content_right_ppt_item_line">
                      </div>
                  </div>
                  <div class="el_pagination">
                        <el-pagination background layout="prev, pager, next" :page-size="9" :total="total"
                            @current-change="pageChange">
                        </el-pagination>
                    </div>
              </div>
              <div v-else
                    style="height: 100%; width: 100%;  display: flex; justify-content: center; color: #333333;">
                    <img style="height: 50%; width: 40%; object-fit: cover;"  src="../images/bgk.jpg"/>
                     
                </div>
          </div>
          <div class="zxkc_content_right_type2" v-if="type == '学生获奖'">
            <div  class="zxkc_content_right_ppt" v-if="listShow.length > 0"  >
                  <div class="zxkc_content_right_ppt_item" v-for="(item, index) in  listShow">
                      <div class="zxkc_content_right_ppt_item_text">
                        <div style="width: 10%;font-size: 16px;color: #333333;text-align: center; border-right: 1.5px solid #070002; border-color: rgba(0, 0, 0, 0.1);display: -webkit-box;
-webkit-line-clamp: 1;
-webkit-box-orient: vertical;
overflow: hidden;
text-overflow: ellipsis;">{{ item.studentName}}</div>
                          <div class="zxkc_content_right_ppt_item_text_left_unactive" :class="item.active == true ? 'zxkc_content_right_ppt_item_text_left' : ''"  @mouseover="item.active = true"
                          @mouseleave="item.active = false" @click="toDetail(item)">{{ item.title }}</div>
                          <div class="zxkc_content_right_ppt_item_text_right" @click="toDetail(item)" >在线预览>></div>
                      </div>
                      <div class="zxkc_content_right_ppt_item_line">
                      </div>
                  </div>
                  <div class="el_pagination">
                        <el-pagination background layout="prev, pager, next" :page-size="9" :total="total"
                            @current-change="pageChange">
                        </el-pagination>
                    </div>
              </div>
              <div v-else
                    style="height: 100%; width: 100%;  display: flex; justify-content: center; color: #333333;">
                    <img style="height: 50%; width: 40%; object-fit: cover;"  src="../images/bgk.jpg"/>
                     
                </div>
          </div>
      </div>

  </div>
</template>
<script>
import { url } from '../services/url'
import {
    getXszpList
} from "../services/services";
export default {
    name: 'Index',
    data() {
        return {
            type: '主要赛事',
            total: 1,
            pageSize: 9,
            pageNum: 1,
            listShow: [],
            userId:localStorage.getItem('userId'),
            getUrl: url
        }
    },
    created() {
        const loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
        getXszpList(this.userId, this.type, this.pageNum, this.pageSize).then(res => {
            this.total = res.total
            this.listShow = res.rows
            console.log(res)
            loading.close()
        })

    },
    methods: {
        changeType(type) {
            this.pageNum = 1
            this.type = type
            getXszpList(this.userId, this.type, this.pageNum, this.pageSize).then(res => {
                this.total = res.total
                this.listShow = res.rows
                console.log(res)
          

            }).catch(err => {
             

            })

        },
        pageChange(e) {
            this.pageNum = e
            getXszpList(this.userId, this.type, this.pageNum, this.pageSize).then(res => {
                this.total = res.total
                this.listShow = res.rows
            }).catch(err => {

            })
        },
        toDetail(item) {
            if ((item.fileUrl == null || item.fileUrl == '') && (item.outUrl == null || item.outUrl == '')) {
                this.$notify({
                    title: '提示',
                    message: '当前没有资源',
                    duration: 2000
                });
                return

            }
            else if (item.outUrl != null && item.outUrl != '') {
                window.open(item.outUrl, "_blank")
            }
            else{
                window.open(this.getUrl + item.fileUrl, "_blank")
                // this.$router.push({
                //         path: '/ViewPpt',
                //         query: {
                //             url: this.getUrl + item.fileUrl
                //         }
                //     });
            }
        }
    },
}
</script>
<style>
/* 或者本地文件 */
@import url('../css/style.css');
</style>